/**
 * Organization brand utilities shared by the main headers (Header.vue, SignHeader.vue).
 */

import { computed } from 'vue';
import { useStore } from 'vuex';
import documillLogo from '../assets/img/documill-logo-32x32.svg';

/**
 * Organization's brand logo URL, falling back to the default Documill logo when the
 * organization has no custom brand configured.
 *
 * @return {import('vue').ComputedRef<String>} the header logo URL
 */

function useHeaderLogoUrl() {
  const store = useStore();

  return computed(() => {
    const brand = store.getters.getOrganizationBrand;

    if(brand && brand.logoId)
      return window.FlowSignOnlyWebsiteGlobalConfig.basePaths.flowController + "/v1/organization/brand/image/" + brand.logoId;

    return documillLogo;
  });
}

export { useHeaderLogoUrl };
